const WECOM_TEST_REDIRECT_KEY = "wecom_test_redirect";
const PROD_ADMIN_API_BASE_URL = "https://api.52choujiang.cn/lotto/admin/api/v1";
const TEST_ADMIN_API_BASE_URL = process.env.VUE_APP_LOTTO_ADMIN_TEST_API_BASE_URL
  || "https://test-lotto.weiyoubot.cn/lotto/admin/api/v1";

function getAdminApiUrl(path) {
  const shouldUseTestApi = typeof window !== "undefined"
    && process.env.NODE_ENV !== "production"
    && Boolean(window.localStorage.getItem(WECOM_TEST_REDIRECT_KEY));
  if (!shouldUseTestApi) {
    return `${PROD_ADMIN_API_BASE_URL}${path}`;
  }
  return new URL(`${TEST_ADMIN_API_BASE_URL}${path}`, window.location.origin).toString();
}

function pickUid(app) {
  return app.uid ?? app._id ?? app.user_id ?? app.userId ?? "";
}

export function normalizeVerificationApplication(app) {
  return {
    id: app.unionid,
    uid: pickUid(app),
    full_name: app.full_name,
    username: app.op_name || "",
    op_phone: app.op_phone || "",
    email: app.email,
    phone: app.phone,
    type: app.type,
    status: app.status,
    createdAt: app.last_commit,
    reason: app.reason,
    license_no: app.license_no || "",
    legal_person: app.legal_person || "",
    documents: [
      {
        id: 1,
        name: app.type == 4 ? "公众号截图" : "营业执照",
        url: app.license_pic || "",
      },
    ],
    auth_time: app.auth_time,
    code_stat: app.code_status,
    auth_code: app.auth_code,
    sms: app.sms,
    rejectReason: app.reason,
  };
}

export function buildVerificationAuditRequest(application, status, reason = "") {
  const body = {
    uid: application.uid,
    status,
  };

  if (status === "rejected") {
    body.refuse_reason = reason.trim();
  }

  return {
    endpoint: getAdminApiUrl("/auth"),
    body,
  };
}

export function buildVerificationDocumentPreview(document) {
  return {
    visible: true,
    document,
  };
}

export function getVerificationDescriptionColumn(width) {
  return width < 768 ? 1 : 2;
}
